const TICK = 250;
const RETRY_WHEN_BUSY = 1000;

// Atualização periódica com contagem regressiva, o componente precisa implementar fetch() retornando uma Promise
export default (interval = 10000) => ({
    data() {
        return {
            refresh: { remaining: 0, interval, loading: false, error: false, lastUpdate: null, pending: false },
            refreshTimer: null,
        };
    },

    mounted() {
        this.refreshTimer = setInterval(this.refreshTick, TICK);
    },

    beforeDestroy() {
        clearInterval(this.refreshTimer);
    },

    methods: {
        // Força uma atualização imediata, se já existir uma em andamento executa logo depois dela
        refreshNow() {
            if (this.refresh.loading) {
                this.refresh.pending = true;
            } else {
                this.refresh.remaining = 0;
            }
        },
        refreshTick() {
            if (this.refresh.loading) return;
            this.refresh.remaining -= TICK;
            if (this.refresh.remaining <= 0) {
                this.refreshRequest();
            }
        },
        refreshRequest() {
            this.refresh.loading = true;
            this.fetch()
                .then(() => {
                    this.refresh.error = false;
                    this.refresh.lastUpdate = this.$moment().format("HH:mm:ss");
                    this.refresh.remaining = this.refresh.interval;
                })
                .catch((error) => {
                    // Sem erro significa que o $http ignorou a chamada por já existir outra em andamento, então tenta de novo logo
                    if (error === undefined) {
                        this.refresh.remaining = RETRY_WHEN_BUSY;
                    } else {
                        this.refresh.error = true;
                        this.refresh.remaining = this.refresh.interval;
                    }
                })
                .finally(() => {
                    this.refresh.loading = false;
                    if (this.refresh.pending) {
                        this.refresh.pending = false;
                        this.refresh.remaining = 0;
                    }
                });
        },
    },
});
